import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { Funcoes } from '../funcoes';
import { UsuariosCargosNomesService } from './usuarios-cargos-nomes.service';
import { UsuariosCargosNomesModel } from './usuarios-cargos-nomes.model';
import { Components } from '../shared/components/components';
import { TranslateService } from '@ngx-translate/core';
import { Global } from '../global';

@Component({
  selector: 'app-usuarios-cargos-nomes-form',
  templateUrl: './usuarios-cargos-nomes-form.component.html'
})
export class UsuariosCargosNomesFormComponent extends Components implements OnInit {

  form: FormGroup;
  title: string;
  item: UsuariosCargosNomesModel = new UsuariosCargosNomesModel();
  pageIsUpd: boolean = false;
  pageIsAdd: boolean = false;
  enviando = false;

  constructor(
    formBuilder: FormBuilder,
    public router: Router,
    private route: ActivatedRoute,
    private service: UsuariosCargosNomesService,
    private _location: Location,
    public func: Funcoes,
    public translate: TranslateService,
    public global: Global
  ) {
    super();
    this.form = formBuilder.group({
      id: [],
      nome_pt: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(45)]],
      nome_en: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(45)]],
      nome_es: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(45)]]
    });
  }

  ngOnInit() {
    if (this.router.url.split(/\//).pop() == 'upd') {
      this.pageIsUpd = true;
    }
    if (this.router.url.split(/\//).pop() == 'add') {
      this.pageIsAdd = true;
    }

    this.route.params.subscribe(params => {
      let id = params['id'];

      if (!this.pageIsUpd && !this.pageIsAdd) {
        this.title = this.func.traduzir('front.visualizarCargo');
      } else if (this.pageIsUpd) {
        this.title = this.func.traduzir('front.editarCargo');
      } else {
        this.title = this.func.traduzir('front.cadastrarNovoCargo');
      }

      if (id) {
        this.service.getById(id).subscribe(json => {
          this.item = json.Payload[0];
          if (this.pageIsUpd) {
            this.title += ': ' + this.item.nome_pt;
          }
        }, error => {
          this.func.showErro(error.json());
        });
      }
    });
  }

  voltar() {
    this._location.back();
  }

  save() {
    this.enviando = true;
    let result;

    if (this.item.id) {
      result = this.service.editar(this.item, this.item.id);
    } else {
      result = this.service.adicionar(this.item);
    }

    result.subscribe(data => this.router.navigate(['/painel', 'usuarios', 'cargos']),
      error => {
        this.enviando = false;
        let json = error.json();
        this.trataErro(json);

        if (json.Message && json.Message.ErrorInput) {
          for (let i in json.Message.ErrorInput) {
            let erro = {};
            erro[i] = json.Message.ErrorInput[i];
            if (this.form.controls[i]) {
              this.form.controls[i].setErrors(erro);
            }
          }
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/usuarios-cargos-nomes/usuarios-cargos-nomes-form.component.ts